//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'
import Login from '../../components/auth/Login'
import Register from '../../components/auth/Register'
import ForgotPassword from '../../components/auth/ForgotPassword'

export default {
  name: 'Auth',
  components: {
    Login,
    Register,
    ForgotPassword
  },
  data () {
    return {
      showForgotPassword: false
    }
  },
  head () {
    return {
      title: this.$getPageTitle('Auth')
    }
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  created () {
    if (this.currentUser) {
      return this.$router.push({ name: 'profile' })
    }
  }
}
